<input
  appInput
  class="input-element"
  [type]="type"
  [textMask]="to.mask"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
